// Match the existing explicit "no option" choices used by checkout validation.
const skipChoices = ["No Dressing Please!", "No Crunches"];
export const requiredOptionsComplete = (groups = []) => groups.every(group => {
  if (!group || group.optionActive === false) return true;
  const options = group.options || [];
  const selected = options.filter(option => option.active);
  const quantity = selected.reduce((total, option) => total + Number(option.qty || 1), 0);
  const waived = selected.some(option => skipChoices.includes(option.title));
  const minimum = group.isMultiple || Number(group.optionType) === 4 ? Math.max(1, Number(group.minQty) || 1) : 1;
  if (group.optionRequired && options.length && (!selected.length || (!waived && quantity < minimum))) return false;
  return selected.every(option => requiredOptionsComplete(option.optionArray || []));
});
